import { render, staticRenderFns } from "./workOrders.vue?vue&type=template&id=ce41153a&scoped=true"
import script from "./workOrders.vue?vue&type=script&lang=js"
export * from "./workOrders.vue?vue&type=script&lang=js"
import style0 from "./workOrders.vue?vue&type=style&index=0&id=ce41153a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce41153a",
  null
  
)

export default component.exports